import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroTexto'
})
export class FiltroTextoPipe implements PipeTransform {

  transform(value: any[], dato: string): any[] {
    let newArr=[]
    
    newArr = value.filter(v => String(v.Descripcion).toLocaleLowerCase().indexOf(dato.toLocaleLowerCase())>-1)

    return newArr
  }

}
